import { render, staticRenderFns } from "./invitation-person.vue?vue&type=template&id=dfc212f2&scoped=true"
import script from "./invitation-person.vue?vue&type=script&lang=js"
export * from "./invitation-person.vue?vue&type=script&lang=js"
import style0 from "./invitation-person.vue?vue&type=style&index=0&id=dfc212f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc212f2",
  null
  
)

export default component.exports